<template lang="pug">
  .inicio-main-dash.prestamo-vida-custom(style="width:100%; background: white !important; min-height: 100vh;")
    // Header personalizado para mobile
    .prestamo-vida-header(v-if="$vuetify.breakpoint.smAndDown")
      v-btn(icon @click="goBack" color="white")
        v-icon arrow_back
      span.prestamo-vida-header-title Solicitud de préstamo
    
    v-flex(xs12 sm12 md10 lg9 style="background: white;")
      v-layout(justify-center column :style="layoutPadding")
      
      // Stepper
      v-flex(xs12 sm12 md12 lg12 style="width: 100%;" v-if="step < 4")
        .stepper-container.d-flex.align-center.justify-center.mb-5
          .step-item.text-center
            .circle(:class="{'active': step === 1, 'completed': step > 1}")
              v-icon(v-if="step > 1" color="white" size="24") check
              span(v-else) 1
            .label(:class="{'active': step === 1, 'completed': step > 1}") Monto
          .step-line(:class="{'active': step > 1}")
          .step-item.text-center
            .circle(:class="{'active': step === 2, 'completed': step > 2}")
              v-icon(v-if="step > 2" color="white" size="24") check
              span(v-else) 2
            .label(:class="{'active': step === 2, 'completed': step > 2}") Destino
          .step-line(:class="{'active': step > 2}")
          .step-item.text-center
            .circle(:class="{'active': step === 3, 'completed': step >= 3}")
              v-icon(v-if="step >= 3" color="white" size="24") check
              span(v-else) 3
            .label(:class="{'active': step === 3, 'completed': step >= 3}") Resumen

      // Card Container
      v-flex.prestamo-solicitud-card-container(xs12 sm12 md6 lg4 style="width: 100%; margin: 0 auto; padding: 0 16px; background: white;")
        v-card.prestamo-solicitud-card(elevation="3" style="border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); background: white;")
          // Card Header
          div(v-if="step < 3" style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%; border-bottom: 1px solid #E2E8F0; padding: 20px 24px;")
            h2.omnesMedium(style="color: #0855C4; font-size: 20px; margin: 0;") Préstamo
            .text-right(style="text-align: right;")
              div.omnesMedium(style="color: #3A416F; font-size: 16px; margin-bottom: 2px;") N° Póliza
              div.omnesRegular(style="color: #64748B; font-size: 14px;") {{ poliza ? poliza.policyNumber : '329472' }}

          // Card Body
          v-card-text(style="padding: 24px;")
            // STEP 1: MONTO
            div(v-if="step === 1")
              h3.omnesMedium(style="color: #3A416F; font-size: 16px; margin-bottom: 16px;") ¿Cuánto necesitas?
              
              // Amount Input
              .amount-input-container(:style="montoError ? 'background: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 8px; margin-bottom: 0; position: relative;' : 'background: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 8px; margin-bottom: 16px; position: relative;'")
                .d-flex.align-center(style="height: 56px;")
                  .currency-symbol.d-flex.align-center.justify-center(style="width: 56px; background: #F1F5F9; border-right: 1px solid #E2E8F0; height: 100%; border-radius: 8px 0 0 8px; color: #3A416F;") {{ simboloMoneda }}
                  .input-wrapper(style="flex: 1; position: relative; padding: 0 16px;")
                    label.floating-label(v-if="montoPrestamo" style="position: absolute; top: 4px; left: 16px; font-size: 10px; color: #64748B; font-family: 'Omnes Regular'; line-height: 1;") Monto del préstamo
                    input.monto-input(
                      ref="montoInput"
                      :value="montoPrestamo"
                      @input="onMontoPrestamoInput($event.target.value)"
                      @blur="calcularMensualidad"
                      type="text"
                      inputmode="decimal"
                      pattern="[0-9]*[.,]?[0-9]*"
                      autocomplete="off"
                      :placeholder="montoPrestamo ? '' : placeholderMonto"
                      :style="montoPrestamo ? 'margin-top: 16px; padding: 0; border: none; background: transparent; outline: none; width: 100%; font-size: 16px; color: #3A416F; font-family: Omnes Regular;' : 'padding: 0; border: none; background: transparent; outline: none; width: 100%; font-size: 16px; color: #3A416F; font-family: Omnes Regular;'"
                    )
                  v-icon(style="color: #0855C4; padding-right: 16px;") edit
              p( v-if="montoError" style="color:#E81C7E; font-size:12px; margin-top:0; margin-bottom:16px; padding-left: 50px; display: flex; align-items: flex-start; line-height: 1.2;")
                v-icon(style="color:#E81C7E; font-size:16px; margin-right: 4px;")
                  | error
                span(style="color: #E81C7E; font-size: 12px;")
                  | {{ montoError }}

              // Info Box
              .info-box(style="background: #F1F5F9; border-radius: 8px; padding: 16px; margin-bottom: 24px;")

                div(
                  style="display:flex; align-items:center; justify-content:space-between; width:100%; margin-bottom:12px;"
                )
                  .d-flex.align-center
                    v-icon(size="18" color="#64748B").mr-2 trending_up

                    span.omnesMedium(
                      style="color: #3A416F; font-size: 14px;"
                    )
                      | Tasa efectiva anual (TEA)

                  span.omnesMedium(
                    style="color: #3A416F; font-size: 14px;"
                  )
                    | {{ teaPrestamoDisplay }}

                div(
                  style="display:flex; align-items:center; justify-content:space-between; width:100%;"
                )
                  .d-flex.align-center
                    v-icon(size="18" color="#64748B").mr-2 calendar_today

                    span.omnesMedium(
                      style="color: #3A416F; font-size: 14px;"
                    )
                      | Plazo

                  span.omnesMedium(
                    style="color: #3A416F; font-size: 14px;"
                  )
                    | Libre

              // Message
              .text-center.mb-4(style="text-align: center;")
                h4.omnesMedium(style="color: #3A416F; font-size: 14px; margin-bottom: 4px; text-align: center;") Desde el próximo mes pagas solo intereses.
                p.omnesRegular(style="color: #64748B; font-size: 14px; margin: 0; text-align: center;") El capital lo devuelves cuando quieras

              // Monthly Payment Box
              v-expand-transition
                .monthly-payment-box(
                  v-if="mostrarPago"
                  style="background-color: #0855C4; border-radius: 8px; padding: 24px; text-align: center; margin-bottom: 24px;"
                )

                  p.omnesMedium(
                    style="color: white; font-size: 16px; margin-bottom: 12px;"
                  )
                    | Pago mensual

                  .d-flex.justify-center(
                    style="margin-bottom: 12px;"
                  )
                    .d-inline-flex.align-center

                      img(
                        src="../assets/prestamos-vida/icon_coins1.svg"
                        style="height: 36px; width: 36px; margin-right: 8px;"
                      )

                      span.omnesSemibold(
                        style="color: white; font-size: 32px; line-height: 1;"
                      )
                        | {{ simboloMoneda }}{{ montoMensual }}
                  v-divider(
                      style="border-color: rgba(255,255,255,0.4); margin-bottom: 12px;"
                    )
                  p.omnesRegular(
                    style="color: white; font-size: 12px; margin: 0;"
                  )
                    | Solo incluye el interés

              v-divider.mb-4(style="border-color: #E2E8F0;")

              // Email Info
              p.omnesRegular(style="color: #64748B; font-size: 13px; line-height: 1.5; margin-bottom: 16px;")
                | Este es el correo electrónico al que llegará tu solicitud del préstamo. Si deseas realizar un cambio, ingresa a la opción 
                a(href="#" @click.prevent="$router.push('/mi-perfil')" style="color: #0855C4; text-decoration: underline;") Actualización de datos
                | .

              // Email Input
              v-text-field(
                label="Correo electrónico"
                :value="correoUsuario"
                outline
                readonly
                color="#3A416F"
                style="margin-bottom: 24px;"
              )

              // Actions
              v-btn.omnesMedium.white--text.mb-4.prestamo-vida-btn-primary(block dark depressed style="border-radius: 8px; height: 50px; text-transform: none; font-size: 16px;" @click="validateStep1") Continuar
              
              .text-center(style="display: flex; justify-content: center;")
                a.omnesMedium(href="#" @click.prevent="goBack" style="color: #0855C4; font-size: 14px; text-align: center; text-decoration: underline;") Volver

            // STEP 2: DESTINO
            div(v-if="step === 2")
              h3.omnesMedium(style="color: #3A416F; font-size: 16px; margin-bottom: 16px;") ¿Cómo lo quieres recibir?
              
              v-select(
                v-model="banco"
                :items="bancos"
                label="Banco"
                outline
                hide-details
                color="#0855C4"
                :style="errorBanco ? 'margin-bottom: 0;' : 'margin-bottom: 16px;'"
              )
              p(v-if="errorBanco" style="color:#E81C7E; font-size:12px; margin-top:0; margin-bottom:16px; display: flex; align-items: flex-start; line-height: 1.2;")
                v-icon(style="color:#E81C7E; font-size:16px; margin-right: 4px;")
                  | error
                span(style="color: #E81C7E; font-size: 12px;")
                  | {{ errorBanco }}
            
              
              v-select(
                v-model="tipoCuenta"
                :items="tiposCuenta"
                label="Tipo de cuenta"
                outline
                hide-details
                color="#0855C4"
                :style="errorTipoCuenta ? 'margin-bottom: 0;' : 'margin-bottom: 16px;'"
              )
              p(v-if="errorTipoCuenta" style="color:#E81C7E; font-size:12px; margin-top:0; margin-bottom:16px; display: flex; align-items: flex-start; line-height: 1.2;")
                v-icon(style="color:#E81C7E; font-size:16px; margin-right: 4px;")
                  | error
                span(style="color: #E81C7E; font-size: 12px;")
                  | {{ errorTipoCuenta }}
              // Cuenta Input
              // type=text + inputmode=numeric: en Android evita teclado teléfono (#*+); en iPhone sigue numérico
              v-text-field(
                ref="numeroCuentaInput"
                :value="numeroCuenta"
                :label="cuentaLabel"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                :maxlength="cuentaMaxLength"
                outline
                hide-details
                color="#0855C4"
                autocomplete="off"
                :style="errorCuenta ? 'margin-bottom: 0;' : 'margin-bottom: 16px;'"
                @keydown="soloDigitosKeydown"
                @input="onNumeroCuentaInput"
              )
                template(v-slot:append='')
                  v-icon(style="color: #64748B;") edit
              p(v-if="errorCuenta" style="color:#E81C7E; font-size:12px; margin-top:0; margin-bottom:16px; display: flex; align-items: flex-start; line-height: 1.2;")
                v-icon(style="color:#E81C7E; font-size:16px; margin-right: 4px;")
                  | error
                span(style="color: #E81C7E; font-size: 12px;")
                  | {{ errorCuenta }}

              // Info box
              .d-flex.align-center(style="background: #F1F5F9; border-radius: 4px; padding: 12px; margin-bottom: 24px;")
                v-icon(size="20" color="#64748B" style="margin-right: 8px;") error_outline
                p.omnesRegular(style="color: #3A416F; font-size: 13px; margin: 0;") Debes ser el titular de la cuenta, esta no debe ser mancomunada y debe estar en la misma moneda que tu seguro.
              
              v-divider.mb-4(style="border-color: #E2E8F0;")
              
              // Checkboxes
              .d-flex.align-start.mb-3
                v-icon(size="8" color="#0855C4" style="margin-top: 6px; margin-right: 8px;") circle
                p.omnesRegular(style="color: #64748B; font-size: 12px; margin: 0; line-height: 1.4;") Al continuar acepto las <a href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf" target="_blank" rel="noopener noreferrer" style="color: #3A416F; text-decoration: underline;">condiciones de uso y políticas de privacidad</a>.
              
              .d-flex.align-start(
                :style="errorTerminos ? 'margin-bottom: 0;' : 'margin-bottom: 24px;'"
              )
                v-checkbox(
                  v-model="terminosAceptados"
                  hide-details
                  color="#0855C4"
                  class="terminos-checkbox"
                )
                span.omnesRegular.terminos-label(style="color: #64748B; font-size: 12px; line-height: 1.4;")
                  | Acepto los 
                  a(href="#" @click.prevent="showModalTerminos = true" style="color: #3A416F; text-decoration: underline;") términos y condiciones.
              
              p(v-if="errorTerminos" style="color:#E81C7E; font-size:12px; margin-top:0; margin-bottom:24px; display: flex; align-items: flex-start; line-height: 1.2;")
                v-icon(style="color:#E81C7E; font-size:16px; margin-right: 4px;")
                  | error
                span(style="color: #E81C7E; font-size: 12px;")
                  | {{ errorTerminos }}
              // Actions
              v-btn.omnesMedium.mb-4.prestamo-vida-btn-primary(
                block
                dark
                depressed
                style="border-radius: 8px; height: 50px; text-transform: none; font-size: 16px;"
                @click="validateStep2"
              )
                | Continuar
                
              .text-center(style="display: flex; justify-content: center;")
                a.omnesMedium(href="#" @click.prevent="step = 1" style="color: #0855C4; font-size: 14px; text-align: center; text-decoration: underline;") Volver

            // STEP 3: RESUMEN
            div(v-if="step === 3" style="margin: -24px; padding-top: 24px;")
              h2.omnesMedium.text-center(style="color: #0855C4; text-align: center; font-size: 20px; margin-bottom: 24px;") Resumen de tu solicitud
              
              .d-flex.justify-space-between.align-center(style="padding: 0 24px 20px 24px;")
                span.omnesMedium(style="color: #64748B; font-size: 14px;") Número de Póliza:
                span.omnesRegular(style="color: #3A416F; text-align: right; font-size: 14px;") {{ poliza ? poliza.policyNumber : '253409' }}
              
              .dashed-divider(style="border-top: 1px dashed #CBD5E1; margin: 0;")
              
              .summary-details(style="background: #F8FAFC; padding: 24px;")
                .d-flex.justify-space-between.align-center.mb-4
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Monto del préstamo
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") {{ simboloMoneda }} {{ montoPrestamo || '0.00' }}
                
                .d-flex.justify-space-between.align-center.mb-4
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Pago interés mensual
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") {{ simboloMoneda }} {{ montoMensual || '0.00' }}
                  
                .d-flex.justify-space-between.align-center.mb-4
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Tasa efectiva anual (TEA)
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") {{ teaPrestamoDisplay }}
                  
                .d-flex.justify-space-between.align-center.mb-4
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Frecuencia de pago
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") Mensual
                  
                .d-flex.justify-space-between.align-center.mb-4
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Banco de destino
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") {{ banco || 'Interbank' }}
                  
                .d-flex.justify-space-between.align-center
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Cuenta de destino
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") ********{{ numeroCuenta ? numeroCuenta.slice(-4) : '2020' }}
                  
              .dashed-divider(style="border-top: 1px dashed #CBD5E1; margin: 0;")
              
              .actions-section(style="padding: 24px;")
                v-btn.omnesMedium.mb-4.prestamo-vida-btn-primary(
                  v-if="!loadingSolicitud"
                  block
                  dark
                  depressed
                  style="border-radius: 8px; height: 50px; text-transform: none; font-size: 16px;"
                  @click="confirmar"
                ) Confirmar
                  
                .text-center(style="display: flex; justify-content: center;")
                  a.omnesMedium(href="#" @click.prevent="volverADatosBancarios" style="color: #0855C4; font-size: 14px; text-align: center; text-decoration: underline;") Volver

            // STEP 4: SUCCESS
            div(v-if="step === 4" style="margin: -24px; padding-top: 32px;")
              .text-center(style="padding: 0 24px;")
                // Success Icon Placeholder
                .d-flex.justify-center.mb-4
                  img(src="@/assets/prestamos-vida/img-prestamo-exitoso.svg" style="height: 90px;")
                
                h2.omnesMedium(style="color: #0855C4; text-align: center; font-size: 20px; margin-bottom: 12px; line-height: 1.3;") ¡Tu solicitud de préstamo<br>N° {{ numeroSolicitud }} fue procesada con éxito!
                
                p.omnesRegular(style="color: #64748B; text-align: center; font-size: 14px; margin-bottom: 24px; line-height: 1.4;") El desembolso se realizará máximo en las siguientes 72 horas hábiles.
                
              .dashed-divider(style="border-top: 1px dashed #CBD5E1; margin: 0;")
              
              .summary-details(style="background: #F8FAFC; padding: 24px;")
                .d-flex.justify-space-between.align-center.mb-4
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Monto del préstamo
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") {{ simboloMoneda }} {{ montoPrestamo || '0.00' }}
                  
                .d-flex.justify-space-between.align-center.mb-4
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Banco de destino
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") {{ banco || 'Interbank' }}
                  
                .d-flex.justify-space-between.align-center
                  span.omnesMedium(style="color: #3A416F; font-size: 14px; font-weight: 600;") Cuenta de destino
                  span.omnesSemibold(style="color: #3A416F; text-align: right; font-size: 14px; font-weight: 600;") ********{{ numeroCuenta ? numeroCuenta.slice(-4) : '2020' }}
                  
              .dashed-divider(style="border-top: 1px dashed #CBD5E1; margin: 0;")
              
              .actions-section(style="padding: 24px;")
                v-btn.omnesMedium.mb-4.prestamo-vida-btn-primary(
                  block
                  dark
                  depressed
                  style="border-radius: 8px; height: 50px; text-transform: none; font-size: 16px;"
                  @click="goToMain"
                ) Ir al menú principal
                  
                .info-box(style="background: #F1F5F9; border-radius: 4px; padding: 16px; display: flex; align-items: flex-start;")
                  v-icon(size="18" color="#64748B" style="margin-right: 8px; margin-top: 2px;") access_time
                  p.omnesRegular(style="color: #64748B; font-size: 13px; margin: 0; line-height: 1.4;") Enviamos el detalle del préstamo a tu correo electrónico registrado.

      //- LOADER PROCESS (mismo patrón que Home)
      v-dialog(v-model="loadingSolicitud" persistent width="300")
        v-card(color="primary" dark="")
          v-card-text
            | Procesando solicitud...
            v-progress-linear.mb-0(indeterminate="" color="white")

      // Modal Términos y Condiciones (click fuera cierra sin marcar el checkbox)
      v-dialog(v-model="showModalTerminos" max-width="450")
        v-card(style="border-radius: 12px; padding: 32px 24px;")

          v-card-text(style="padding: 0;")

            // Title
            h2.omnesMedium(style="color: #0855C4; font-size: 20px; margin-bottom: 24px; text-align: center;")
              | Términos y condiciones

            // Content
            div( style=" color: #64748B; font-size: 12px; line-height: 1.5; margin-bottom: 24px; text-align: justify; max-height: 320px; overflow-y: auto; padding-right: 4px;")

              p.omnesRegular(style="margin-bottom: 12px;")
                | 1. Las solicitudes de préstamo por este canal aplican únicamente para seguros de Vida Individual correspondientes a los productos Plan Garantizado - código SBS VI2027100146, Educacional Sura - código SBS VI2057120017, Educ Garantizado Plus New y Educación Garantizado Plus - código SBS VI2027100135, de conformidad con las Condiciones Generales de la póliza.

              p.omnesRegular(style="margin-bottom: 12px;")
                | 2. A la fecha de la solicitud, el nivel de endeudamiento total comprendido por capital e intereses no deberá exceder el valor de rescate de la póliza. De superarse dicho límite, se realizará un rescate total anticipado. En tal supuesto, el contratante deberá comunicarse con la compañía a la mayor brevedad a través de los canales de atención habilitados para su regularización. De no hacerlo, el contrato de seguro podrá resolverse de pleno derecho al no existir valores de rescate asociados.

              p.omnesRegular(style="margin-bottom: 12px;")
                | 3. El monto del préstamo no deberá exceder el ochenta por ciento (80%) del valor de rescate de la póliza.

              p.omnesRegular(style="margin-bottom: 12px;")
                | 4. En caso de siniestro, el saldo del préstamo y sus intereses serán descontados del beneficio asegurado.

              p.omnesRegular(style="margin-bottom: 12px;")
                | 5. No se realizarán endosos de disminución de suma asegurada en pólizas que mantengan préstamos vigentes.

              p.omnesRegular(style="margin-bottom: 12px;")
                | 6. El solicitante debe ser titular de la cuenta bancaria registrada, la cual deberá estar en la misma moneda que la póliza.

              p.omnesRegular(style="margin-bottom: 12px;")
                | 7. La moneda del monto solicitado debe coincidir con la moneda de la póliza.

              p.omnesRegular(style="margin-bottom: 12px;")
                | 8. El saldo de intereses del préstamo podrá ser visualizado en el estado de cuenta de la póliza.

              p.omnesRegular(style="margin-bottom: 0;")
                | 9. Los intereses del préstamo serán cobrados de forma mensual, a partir del mes siguiente al desembolso. Dicho cobro se realizará a través del medio de pago.

            // Action
            v-btn.omnesMedium.prestamo-vida-btn-primary(
              block
              dark
              depressed
              style="border-radius: 8px; height: 50px; text-transform: none; font-size: 16px;"
              @click="aceptarTerminosYContinuar"
            )
              | Aceptar y continuar
      // Modal Importante
      v-dialog(v-model="showModalConfirmacion" persistent max-width="350")
        v-card(style="border-radius: 12px; padding: 32px 24px;")
          v-card-text.text-center(style="padding: 0;")
            // Character Image
            .d-flex.justify-center.mb-4
              div(style="width: 120px; height: 120px; display: flex; align-items: center; justify-content: center; overflow: hidden;")
                img(
                  src="@/assets/characters/informa.svg"
                  style="width: 100%; height: 100%; object-fit: contain;"
                )
            
            // Title
            h2.omnesMedium(style="color: #0855C4; font-size: 20px; margin-bottom: 24px;text-align: center;") ¡Importante!
            
            // List
            p(style="color: #64748B; font-family: 'Omnes Regular'; font-size: 12px; line-height: 1.5; margin-bottom: 32px; padding: 0 16px; text-align: center;")
              | Recuerda que&nbsp;
              span.omnesMedium si tu deuda
              | &nbsp;(capital más intereses) supera el valor de rescate de tu póliza,&nbsp;
              span.omnesMedium el seguro se liquidará para saldar la cuenta y el contrato se dará por terminado.
              | &nbsp;Evita que esto suceda manteniendo tus pagos al día.
            // Action
            v-btn.omnesMedium.prestamo-vida-btn-primary(block dark depressed style="border-radius: 8px; height: 50px; text-transform: none; font-size: 16px;" @click="aceptarAvisoRescate") Entendido
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { BANCOS, TIPOS_CUENTA, obtenerDigitosRequeridos, obtenerEtiquetaCuenta, sanitizarNumeroCuenta, validarNumeroCuenta } from '@/utils/prestamosVidaCuentaBancaria'
import { sanitizarMontoPrestamo } from '@/utils/prestamosVidaMontoUtil'
import {
  formatearTeaDisplay,
  formatearTasaInteresParaSolicitud,
  formatearPagoInteresMensual
} from '@/utils/prestamosVidaInteresUtil'
import {
  showPrestamosVidaAtencionAlert,
  showPrestamosVidaErrorAlert
} from '@/utils/prestamosVidaAlertUtil'

export default {
  name: 'PrestamoVidaSolicitud',
  /**
   * Bloquea F5 / deep link / tab nueva: solo se llega navegando desde PrestamoVida.
   * Entrada directa = from.matched vacío (ubicación inicial de Vue Router 3).
   */
  beforeRouteEnter (to, from, next) {
    if (!from || from.matched.length === 0) {
      next({ path: '/inicio' })
      return
    }
    next()
  },
  data () {
    return {
      poliza: null,
      montos: null,
      montoMinimo: 100,
      montoMaximo: 0,
      interesPrestamo: '0.8',
      teaPrestamo: '',
      simboloMoneda: 'S/',
      step: 1,
      montoPrestamo: '',
      montoMensual: '0.00',
      mostrarPago: false,
      banco: null,
      bancos: BANCOS,
      tipoCuenta: null,
      tiposCuenta: TIPOS_CUENTA,
      numeroCuenta: '',
      terminosAceptados: false,
      avisoRescateAceptado: false,
      showModalConfirmacion: false,
      showModalTerminos: false,
      montoError: '',
      errorBanco: '',
      errorTipoCuenta: '',
      errorCuenta: '',
      errorTerminos: '',
      numeroSolicitud: '',
      solicitudUuid: '',
      loadingSolicitud: false,
    }
  },
  computed: {
    ...mapGetters('user', ['basicInfo', 'prestamosVidaPorPoliza', 'polizasInfo', 'polizasVidaVehicular']),
    correoUsuario () {
      return (this.basicInfo && this.basicInfo.correo) ? this.basicInfo.correo : ''
    },
    teaPrestamoDisplay () {
      return formatearTeaDisplay(this.teaPrestamo)
    },
    isStep2Valid () {
      return this.banco && this.tipoCuenta && this.numeroCuenta && this.terminosAceptados
    },
    cuentaLabel () {
      if (!this.banco || !this.tipoCuenta) return 'Número de cuenta'
      return obtenerEtiquetaCuenta(this.banco, this.tipoCuenta)
    },
    cuentaMaxLength () {
      if (!this.banco || !this.tipoCuenta) return null
      const digitos = obtenerDigitosRequeridos(this.banco, this.tipoCuenta)
      return digitos > 0 ? digitos : null
    },
    placeholderMonto () {
      const formateado = Number(this.montoMaximo).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      return `Monto máximo ${formateado}`
    },
    layoutPadding () {
      // En mobile, reducir el padding superior
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'padding: 0px 0 20px 0; background: white;'
      }
      // En desktop, reducir padding superior para evitar espaciado excesivo
      return 'padding: 20px 0; background: white;'
    }
  },
  watch: {
    banco () {
      this.numeroCuenta = ''
      this.errorCuenta = ''
      this.errorBanco = ''
    },
    tipoCuenta () {
      this.numeroCuenta = ''
      this.errorCuenta = ''
      this.errorTipoCuenta = ''
    },
    numeroCuenta () {
      if (this.errorCuenta) {
        this.errorCuenta = ''
      }
    },
    terminosAceptados (valor) {
      if (valor) {
        this.errorTerminos = ''
      }
    }
  },
  mounted () {
    this.inicializarContexto()
  },
  methods: {
    ...mapActions('user', ['getPolizasVidaVehicular', 'registrarSolicitudPrestamoVida']),
    ...mapMutations('user', ['marcarSolicitudPrestamoVidaEnEvaluacion']),
    inicializarContexto () {
      if (this.$route.params.poliza) {
        this.poliza = this.$route.params.poliza
      } else if (this.$route.query.numeroPoliza) {
        this.poliza = { policyNumber: this.$route.query.numeroPoliza }
      }

      if (this.aplicarMontos(this.$route.params.montos)) {
        return
      }
      if (this.poliza && this.aplicarMontos(this.poliza.montos)) {
        return
      }
      if (this.poliza && this.poliza.policyNumber) {
        const montosCache = this.prestamosVidaPorPoliza(this.poliza.policyNumber)
        if (montosCache && montosCache.prestamoDisponible && this.aplicarMontos(montosCache)) {
          if (!this.poliza.name) {
            this.enriquecerPolizaDesdeCatalogo(this.poliza.policyNumber)
          }
          return
        }
      }

      // Sin montos utilizables en params/caché: volver a selección.
      this.$router.replace('/prestamos-vida')
    },
    obtenerPolizasCatalogo () {
      if (this.polizasInfo && this.polizasInfo.length) {
        return Promise.resolve(this.polizasInfo)
      }
      if (this.polizasVidaVehicular && this.polizasVidaVehicular.length) {
        return Promise.resolve(this.polizasVidaVehicular)
      }
      return this.getPolizasVidaVehicular()
        .then(res => (res.data && res.data.polizas) ? res.data.polizas : [])
        .catch(() => [])
    },
    enriquecerPolizaDesdeCatalogo (numeroPoliza) {
      return this.obtenerPolizasCatalogo().then(policies => {
        const item = policies.find(p => p.numeroPoliza === numeroPoliza)
        if (item) {
          this.poliza = {
            policyNumber: item.numeroPoliza,
            name: item.producto,
            ramo: item.ramo,
            montos: this.montos
          }
        }
      })
    },
    getSimboloMoneda (moneda) {
      if (!moneda) return 'S/'
      const m = moneda.toLowerCase()
      if (m.includes('dolar') || m.includes('dólar') || m.includes('usd')) return '$'
      return 'S/'
    },
    parseMonto (valor) {
      if (valor === null || valor === undefined || valor === '') return 0
      const normalizado = String(valor).replace(/,/g, '')
      const parsed = parseFloat(normalizado)
      return isNaN(parsed) ? 0 : parsed
    },
    /**
     * Aplica al formulario los montos de la póliza.
     * @param {Object} data - Montos de la póliza (montoMinimo, montoMaximo, moneda, interesPrestamo, tea)
     * @returns {boolean} true si el monto máximo es utilizable; false si no hay tope válido
     */
    aplicarMontos (data) {
      if (!data) return false
      const montoMaximo = this.parseMonto(data.montoMaximo)
      if (montoMaximo <= 0) return false

      this.montos = data
      this.montoMinimo = this.parseMonto(data.montoMinimo)
      this.montoMaximo = montoMaximo
      this.interesPrestamo = data.interesPrestamo || '0.8'
      this.teaPrestamo = data.tea || ''
      this.simboloMoneda = this.getSimboloMoneda(data.moneda)
      return true
    },
    goBack () {
      this.$router.push('/prestamos-vida')
    },
    calcularMensualidad () {
      const monto = Number((this.montoPrestamo || '').toString().replace(/,/g, ''))
      const maximo = this.montoMaximo
      const minimo = this.montoMinimo || 0

      if (monto > maximo) {
        this.montoError = `El monto máximo permitido es ${this.simboloMoneda} ${maximo}. Prueba con un monto menor`
        this.mostrarPago = false
        return
      }

      if (monto > 0 && monto < minimo) {
        this.montoError = `El monto mínimo permitido es ${this.simboloMoneda} ${minimo}. Prueba con un monto mayor`
        this.mostrarPago = false
        return
      }

      this.montoError = ''

      if (!isNaN(monto) && monto > 0) {
        this.montoMensual = formatearPagoInteresMensual(monto, this.interesPrestamo)
        this.mostrarPago = true
      } else {
        this.mostrarPago = false
      }
    },
    confirmar () {
      if (!this.poliza || !this.poliza.policyNumber) {
        showPrestamosVidaAtencionAlert(this, 'No se encontró la póliza seleccionada.')
        return
      }
      if (!this.montos) {
        showPrestamosVidaAtencionAlert(this, 'No se encontraron los montos del préstamo.')
        this.$router.replace('/prestamos-vida')
        return
      }
      if (!this.avisoRescateAceptado) {
        this.step = 2
        this.showModalConfirmacion = true
        return
      }

      const payload = {
        numeroPoliza: this.poliza.policyNumber,
        producto: this.poliza.name,
        ramo: this.poliza.ramo,
        moneda: this.montos ? this.montos.moneda : null,
        montoPrestamo: String(this.montoPrestamo || '').replace(/,/g, ''),
        tasaInteres: formatearTasaInteresParaSolicitud(this.interesPrestamo),
        tea: this.teaPrestamo || null,
        pagoInteresMensual: formatearPagoInteresMensual(
          String(this.montoPrestamo || '').replace(/,/g, ''),
          this.interesPrestamo
        ),
        frecuenciaPago: 'MENSUAL',
        montoMinimo: String(this.montoMinimo),
        montoMaximo: String(this.montoMaximo),
        saldoValorGarantia: this.montos ? this.montos.saldoValorGarantia : null,
        porcentajeSumaAsegurada: this.montos ? this.montos.porcentajeSumaAsegurada : null,
        correo: this.correoUsuario,
        terminosAceptados: this.terminosAceptados,
        avisoRescateAceptado: this.avisoRescateAceptado,
        medioDevolucion: {
          banco: this.banco,
          tipoCuenta: this.tipoCuenta,
          numeroCuenta: this.numeroCuenta,
          medio: 'Transferencia bancaria'
        }
      }

      this.loadingSolicitud = true
      this.registrarSolicitudPrestamoVida(payload)
        .then(res => {
          const data = res.data
          if (data && data.codigoRespuesta === '01') {
            this.numeroSolicitud = data.codigoSolicitud
            this.solicitudUuid = data.uuid
            this.marcarSolicitudPrestamoVidaEnEvaluacion()
            this.step = 4
          } else {
            showPrestamosVidaAtencionAlert(
              this,
              (data && data.mensajeRespuesta) || 'No se pudo registrar la solicitud.'
            )
          }
        })
        .catch(() => {
          showPrestamosVidaErrorAlert(this, 'No se pudo registrar la solicitud de préstamo.')
        })
        .finally(() => {
          this.loadingSolicitud = false
        })
    },
    goToMain () {
      this.$router.push('/inicio')
    },
    validateStep1 () {
      const montoTexto = String(this.montoPrestamo || '').replace(/,/g, '')
      const monto = Number(montoTexto)
      const maximo = this.montoMaximo
      const minimo = this.montoMinimo || 100

      this.montoError = ''

      if (!/^\d+(\.\d{1,2})?$/.test(montoTexto) || monto < 0) {
        this.montoError = 'Usa solo números en el monto. Verifica el valor ingresado'
        return
      }

      if (monto > maximo) {
        this.montoError = `El monto máximo permitido es ${this.simboloMoneda} ${maximo}. Prueba con un monto menor`
        return
      }

      if (monto < minimo) {
        this.montoError = `El monto mínimo permitido es ${this.simboloMoneda} ${minimo}. Prueba con un monto mayor`
        return
      }

      this.step = 2
    },
    /**
     * Sincroniza el valor del input nativo cuando Vue omite el re-render
     * (mismo string sanitizado que el data anterior).
     * @param {HTMLInputElement|null} el
     * @param {string} valor
     */
    sincronizarValorInput (el, valor) {
      if (el && el.value !== valor) {
        el.value = valor
      }
    },
    /**
     * Sanitiza el monto en cada input (desktop y mobile): solo dígitos y hasta 2 decimales.
     * @param {string} valor
     */
    onMontoPrestamoInput (valor) {
      const sanitizado = sanitizarMontoPrestamo(valor)
      this.montoPrestamo = sanitizado
      this.sincronizarValorInput(this.$refs.montoInput, sanitizado)
    },
    /**
     * Bloquea al escribir cualquier carácter que no sea dígito (desktop y mobile).
     * Usa keydown (más fiable que keypress en Android).
     * @param {KeyboardEvent} event
     */
    soloDigitosKeydown (event) {
      if (event.ctrlKey || event.metaKey || event.altKey) return
      if (event.key.length !== 1) return
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault()
      }
    },
    /**
     * Sanitiza el número de cuenta en cada input (desktop y mobile): solo dígitos.
     * Cubre pegado y soft keyboards; sincroniza lazyValue de Vuetify 1.5 para que no reaparezcan símbolos.
     * @param {string} valor
     */
    onNumeroCuentaInput (valor) {
      const sanitizado = sanitizarNumeroCuenta(valor, this.banco, this.tipoCuenta)
      this.numeroCuenta = sanitizado
      this.$nextTick(() => {
        const field = this.$refs.numeroCuentaInput
        if (!field) return
        if (field.lazyValue !== sanitizado) {
          field.lazyValue = sanitizado
        }
        const el = field.$refs.input || (field.$el && field.$el.querySelector('input'))
        this.sincronizarValorInput(el, sanitizado)
      })
    },

    aceptarTerminosYContinuar () {
      this.terminosAceptados = true
      this.errorTerminos = ''
      this.showModalTerminos = false
    },
    aceptarAvisoRescate () {
      this.avisoRescateAceptado = true
      this.showModalConfirmacion = false
      this.step = 3
    },
    volverADatosBancarios () {
      this.avisoRescateAceptado = false
      this.step = 2
    },
    validateStep2 () {
      this.errorBanco = ''
      this.errorTipoCuenta = ''
      this.errorCuenta = ''
      this.errorTerminos = ''

      let valid = true

      if (!this.banco) {
        this.errorBanco = 'Selecciona el banco de destino para continuar'
        valid = false
      }

      if (!this.tipoCuenta) {
        this.errorTipoCuenta = 'Selecciona el tipo de cuenta para continuar'
        valid = false
      }

      const errorCuenta = validarNumeroCuenta(this.banco, this.tipoCuenta, this.numeroCuenta)
      if (errorCuenta) {
        this.errorCuenta = errorCuenta
        valid = false
      }

      if (!this.terminosAceptados) {
        this.errorTerminos = 'Revisa y acepta los términos y condiciones para continuar'
        valid = false
      }

      if (!valid) return

      this.avisoRescateAceptado = false
      this.showModalConfirmacion = true
    },
  },
}
</script>

<style scoped>
/* Mismo patrón que Home: var(--fuchsia-color) */
.prestamo-vida-btn-primary {
  background: var(--fuchsia-color) !important;
  color: #fff !important;
}

.prestamo-vida-btn-primary.v-btn--disabled {
  background: #EAEAEA !important;
  color: #9CA3AF !important;
}

.prestamo-solicitud-card-container {
  max-width: 350px;
}

@media only screen and (max-width: 959px) {
  .prestamo-solicitud-card-container {
    max-width: 392px;
  }
}

.stepper-container {
  max-width: 300px;
  margin: 0 auto;
}
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #CBD5E1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CBD5E1;
  font-family: 'Omnes Medium';
  font-size: 18px;
  margin-bottom: 8px;
  background: white;
}
.circle.active {
  background: #0855C4;
  border-color: #0855C4;
  color: #FFFFFF !important;
}
.circle.active span {
  color: #FFFFFF !important;
}
.circle.completed {
  background: #0855C4;
  border-color: #0855C4;
  color: #FFFFFF !important;
}
.circle.completed span {
  color: #FFFFFF !important;
}
.label {
  font-family: 'Omnes Regular';
  font-size: 13px;
  color: #64748B;
}
.label.active {
  color: #0855C4;
}
.label.completed {
  color: #0855C4;
}
.step-line {
  flex: 1;
  height: 2px;
  background: #CBD5E1;
  margin: -25px 8px 0 8px;
}
.step-line.active {
  background: #0855C4;
}
.prestamo-solicitud-card {
  background: #FFFFFF;
}
.monto-input >>> .v-input__control {
  min-height: auto;
}
.monto-input >>> .v-input__slot {
  box-shadow: none !important;
  background: transparent !important;
}

.terminos-checkbox.v-input--selection-controls {
  margin: 0;
  padding: 0;
  flex: 0 0 auto;
  width: auto;
  max-width: max-content;
}

.terminos-checkbox >>> .v-input__control,
.terminos-checkbox >>> .v-input__slot {
  width: auto !important;
  flex-grow: 0;
}

.terminos-checkbox >>> .v-messages {
  display: none;
}

.terminos-label {
  padding-top: 2px;
  margin-left: 8px;
}

.prestamo-vida-header {
  background-color: #0855C4;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 56px;
}

.prestamo-vida-header-title {
  color: white;
  font-family: 'Omnes Medium', sans-serif;
  font-size: 18px;
  margin-left: 16px;
}

@media only screen and (min-width: 960px) {
  .prestamo-vida-custom.inicio-main-dash {
    display: flex !important;
    justify-content: center !important;
    align-items: flex-start !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PrestamoVidaSolicitud.vue